/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';

class CurateTabs extends React.Component {
    constructor(props) {
        super(props);

        this.addNewFeed = this.addNewFeed.bind(this);
    }

    addNewFeed(e) {

        e.preventDefault();

        if (this.props.user.perms.resources.inputsAvailable === 0) {
            this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'curate_banner');
        } else {
            this.props.router.navigate('/share/curate/feeds/new');
        }

    }

    render() {

        let self = this,
            classNames = {
                curateItems: {
                    wrapper: classnames('tab-left curate-items', {
                        'underline': self.props.active === 'curate-items' ? true : false
                    }),
                    icon: classnames('fa fa-list inline-left-icon', {
                        'active': self.props.active === 'curate-items' ? true : false
                    })
                },
                curateFeedsList: {
                    wrapper: classnames('tab-left curate-feeds-list', {
                        'underline': self.props.active === 'curate-feeds-list' ? true : false
                    }),
                    icon: classnames('fa fa-rss inline-left-icon', {
                        'active': self.props.active === 'curate-feeds-list' ? true : false
                    })
                },
                curateFeedsNew: {
                    wrapper: classnames('tab-right curate-feeds-new', {
                        'underline': self.props.active === 'curate-feeds-new' ? true : false
                    }),
                    icon: classnames('fa fa-plus-square inline-left-icon', {
                        'active': self.props.active === 'curate-feeds-new' ? true : false
                    })
                }
            };

        return (
            <div>
                <Breakpoint desktop only>
                    <div className='tab-bar'>
                        <Link to="/share/curate/items" className={classNames.curateItems.wrapper}>
                            <i className={classNames.curateItems.icon}></i>
                            <span>Items</span>
                        </Link>
                        <Link to="/share/curate/feeds/list" className={classNames.curateFeedsList.wrapper}>
                            <i className={classNames.curateFeedsList.icon}></i>
                            <span>Feeds</span>
                        </Link>
                        <a href="#" onClick={this.addNewFeed} className={classNames.curateFeedsNew.wrapper}>
                            <i className={classNames.curateFeedsNew.icon}></i>
                            <span>Add Feed</span>
                        </a>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className='tab-bar mobile'>
                        <div className="new-feed-wrapper">
                            <div className="control new automate" onClick={this.addNewFeed} role="button" aria-label="add new feed">
                                <span className="va-helper"></span>
                                <i className="fa fa-plus-square new-icon"></i> Add New Feed
                            </div>
                        </div>
                        <div className="tab-bar-mobile-links">
                            <Link to="/share/curate/items" className={classNames.curateItems.wrapper}>
                                <i className={classNames.curateItems.icon}></i>
                                <span>Items</span>
                            </Link>
                            <Link to="/share/curate/feeds/list" className={classNames.curateFeedsList.wrapper}>
                                <i className={classNames.curateFeedsList.icon}></i>
                                <span>Feeds</span>
                            </Link>
                        </div>
                    </div>
                </Breakpoint>
            </div>
        );

    }

};

CurateTabs.propTypes = {
    active: PropTypes.string,
    userPerms: PropTypes.object,
    recordPath: PropTypes.func,
    setModal: PropTypes.func
};

CurateTabs.defaultProps = {
    active: 'curate-items',
    userPerms: {},
    recordPath: null,
    setModal: null
};

export default CurateTabs;
